import VideoResourceList from "./VideoResourceList.container";

export default VideoResourceList;
